import {
  URL_CHART_METRIC,
  URL_CHART_TYPE,
  URL_SORT_NAME,
  URL_ORDER,
  URL_SOURCE_NAME,
  URL_PAGE_SIZE,
  URL_RATIO_TYPE,
  URL_TABLE_SCROLL_SEG,
  URL_2_ORDER,
  URL_2_RATIO_TYPE,
  URL_2_SORT_NAME,
  URL_2_CHART_TYPE,
  URL_COUNTRIES_TYPE,
  URL_2_CHART_METRIC,
  URL_RANK_SWITCH,
  ShortLinkPageValidCfgType,
  checkValidQuery,
} from '@intelligence/utils/urlPathCfg';
import {
  pcMetricTableCloums,
  consleMetricTableCloums,
  digitalRevenueList,
  npdList,
  pcuPageList,
  lifetimePlayerList,
  mauList,
  steamSalesList,
  japanSalesList,
  pcMetricTableSegementList,
  consleMetricTableSegementList,
  japanSalesSegOptions,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { ECHARTS_DATASOURCE_METRICS_MAP } from '@intelligence/utils/constant';
import { SteamSalesList } from '@/pages/intelligence/utils/echartsConst';
import { History } from 'umi';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';

const OPENRATIO = true;
const CLOSERATIO = false;
// 这是一个开关，是否写短链接；读不需要开关
export const hasShortLinkRatio = {
  topMobileActiveuser: OPENRATIO,
  topMobileRevenue: OPENRATIO,
  topMobileDownloads: OPENRATIO,
  topMobileDatabrain: OPENRATIO,
  topMobileRpd: OPENRATIO,
  topMobileRetention: OPENRATIO,
  topMobileDemographics: OPENRATIO,
  topMobileNewrelease: OPENRATIO,
  topMobileUpcoming: OPENRATIO,
  topPCMetrictable: OPENRATIO,
  topPCPCU: OPENRATIO,
  topPCDigitalRevenue: OPENRATIO,
  topPCPhysicalRevenue: OPENRATIO,
  topPCSteamSales: OPENRATIO,
  topPCMAU: OPENRATIO,
  topPCLifetimePlayers: OPENRATIO,
  topPCNewrelease: OPENRATIO,
  topPCUpcoming: OPENRATIO,
  topConsoleMetrictable: OPENRATIO,
  topConsoleDigitalRevenue: OPENRATIO,
  topConsolePhysicalRevenue: OPENRATIO,
  topConsoleJapanSales: OPENRATIO,
  topConsoleMAU: OPENRATIO,
  topConsoleLifetimePlayers: OPENRATIO,
  topConsoleNewrelease: OPENRATIO,
  topConsoleUpcoming: OPENRATIO,
  topPCConsoleMetricTable: OPENRATIO,
  topCompaniesRevenue: OPENRATIO,
  topCompaniesDownloads: OPENRATIO,
  topCompaniesMentions: OPENRATIO,
  detailMobileStatsActiveuser: OPENRATIO,
  detailMobileStatsRevenue: OPENRATIO,
  detailMobileStatsDownload: OPENRATIO,
  detailMobileStatsRetention: OPENRATIO,
  detailMobileStatsRetentionLifetime: OPENRATIO,
  detailMobileStatsRPD: OPENRATIO,
  detailMobileCountriesActiveuser: OPENRATIO,
  detailMobileCountriesRevenue: OPENRATIO,
  detailMobileCountriesDownload: OPENRATIO,
  detailMobileCountriesRetention: OPENRATIO,
  detailMobileCountriesRPD: OPENRATIO,
  detailMobileCountriesRetentionLifetime: CLOSERATIO,
  detailMobileDemographics: OPENRATIO,
  detailMobileStreaming: OPENRATIO,
  detailPCStreaming: CLOSERATIO,
  detailConsoleStreaming: CLOSERATIO,
};

export const topchartNewReleaseCommonValidCfg: ShortLinkPageValidCfgType = {
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
};

export const topchartNewReleaseMobileValidCfg: ShortLinkPageValidCfgType = {
  ...topchartNewReleaseCommonValidCfg,
  [URL_SORT_NAME]: [
    'appstore top free',
    'appstore top grossing',
    'googleplay top free',
    'googleplay top grossing',
    'release_time',
  ],
  [URL_ORDER]: ['asc', 'desc'],
  [URL_CHART_TYPE]: ['bar'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_METRIC]: [
    'appstore top free',
    'appstore top grossing',
    'googleplay top free',
    'googleplay top grossing',
  ],
};

export const topchartNewReleasePCValidCfg: ShortLinkPageValidCfgType = {
  ...topchartNewReleaseCommonValidCfg,
  [URL_SORT_NAME]: ['gamalytic__pcu', 'steam new and trending', 'release_time'],
  [URL_ORDER]: ['desc', 'asc'],
  [URL_CHART_TYPE]: ['bar', 'line', 'pie'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_METRIC]: ['gamalytic__pcu', 'steam new and trending'],
};

export const topchartNewReleaseConsoleValidCfg: ShortLinkPageValidCfgType = {
  ...topchartNewReleaseCommonValidCfg,
  [URL_SORT_NAME]: ['xbox new release', 'playstation new games', 'release_time'],
  [URL_ORDER]: ['asc', 'desc'],
  [URL_CHART_TYPE]: ['bar'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_METRIC]: ['xbox new release', 'playstation new games'],
};

export const getTopNewReleaseCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    ratio_type: validParams?.[URL_RATIO_TYPE],
    order: validParams?.[URL_ORDER],
    order_metric: validParams?.[URL_SORT_NAME],
  };
  return { params, validQuery: validParams };
};

export const topchartUpcomingValidCfg: ShortLinkPageValidCfgType = {
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
  [URL_CHART_TYPE]: ['bar'],
};

export const topchartUpcomingMobileValidCfg: ShortLinkPageValidCfgType = {
  ...topchartUpcomingValidCfg,
  [URL_SORT_NAME]: ['release_time'],
  [URL_RATIO_TYPE]: ['0'],
  [URL_ORDER]: ['asc', 'desc'],
};

export const topchartUpcomingPCValidCfg: ShortLinkPageValidCfgType = {
  ...topchartUpcomingValidCfg,
  [URL_CHART_METRIC]: ['steam top wish lists', 'steamfollowers'],
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_SORT_NAME]: ['steam top wish lists', 'steamfollowers', 'release_time'],
};

export const topchartUpcomingConsoleValidCfg: ShortLinkPageValidCfgType = {
  ...topchartUpcomingValidCfg,
  [URL_ORDER]: ['asc', 'desc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_SORT_NAME]: ['xbox upcoming', 'playstation coming soon', 'release_time'],
  [URL_CHART_METRIC]: ['xbox upcoming', 'playstation coming soon'],
};

export const getTopUpcomingCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    ratio_type: validParams?.[URL_RATIO_TYPE],
    order: validParams?.[URL_ORDER],
    order_metric: validParams?.[URL_SORT_NAME], // TODO 拿它找到对应的列表value值
  };
  return { params, validQuery: validParams };
};

// 页面的有效配置
const topchartActiveruserValidCfg: ShortLinkPageValidCfgType = {
  [URL_CHART_TYPE]: ['bar', 'line', 'pie'],
  [URL_CHART_METRIC]: [],
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_SOURCE_NAME]: ['appannie', 'sensortower'],
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
};

export const topchartMobileActiveruserValidCfg: ShortLinkPageValidCfgType = {
  ...topchartActiveruserValidCfg,
  [URL_SORT_NAME]: ['dau', 'revenue', 'download', 'arpu'],
};

export const topchartMobileRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartActiveruserValidCfg,
  [URL_SORT_NAME]: ['revenue', 'arpu'],
};

export const topchartMobileDownloadValidCfg: ShortLinkPageValidCfgType = {
  ...topchartActiveruserValidCfg,
  [URL_SORT_NAME]: ['download'],
};
export const topchartMobileDatabrainValidCfg: ShortLinkPageValidCfgType = {
  ...topchartActiveruserValidCfg,
  [URL_SOURCE_NAME]: ['appannie', 'sensortower', 'ogdb'],
  [URL_SORT_NAME]: ['dau', 'revenue', 'download'],
};

export const getTopMobilesCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    page_size: validParams?.[URL_PAGE_SIZE],
    order: validParams?.[URL_ORDER],
    ratio_type: validParams?.[URL_RATIO_TYPE],
    order_metric: validParams?.[URL_SORT_NAME],
    order_source: validParams?.[URL_SOURCE_NAME],
  };
  return { params, validQuery: validParams };
};

export const topchartMobileRpdValidCfg: ShortLinkPageValidCfgType = {
  [URL_CHART_TYPE]: ['bar', 'line'],
  [URL_CHART_METRIC]: ['rpd', 'revenue', 'download'],
  [URL_ORDER]: ['desc', 'asc'],
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
  [URL_SORT_NAME]: ['rpd', 'revenue', 'download'],
};

export const getTopMobilesRPDCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    page_size: validParams?.[URL_PAGE_SIZE],
    order: validParams?.[URL_ORDER],
    order_metric: validParams?.[URL_SORT_NAME],
  };
  return { params, validQuery: validParams };
};

export const topchartMobileRetentionValidCfg: ShortLinkPageValidCfgType = {
  // [URL_CHART_TYPE]: ['line'],
  [URL_CHART_METRIC]: ['D2', 'D3', 'D7', 'D15', 'D31'],
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
  [URL_SORT_NAME]: ['mau', 'D2', 'D3', 'D7', 'D15', 'D31'],
};

export const getTopMobilesRetentionCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    page_size: validParams?.[URL_PAGE_SIZE],
    order: validParams?.[URL_ORDER],
    ratio_type: validParams?.[URL_RATIO_TYPE],
    order_metric: validParams?.[URL_SORT_NAME],
  };
  return { params, validQuery: validParams };
};

export const topchartMobileDemographicsValidCfg: ShortLinkPageValidCfgType = {
  [URL_CHART_METRIC]: ['gender', 'age'],
  [URL_ORDER]: ['desc', 'asc'],
  // 这里的ratio_type是用于mau的参数ratio_type， 和gender/age的order_type一起用
  [URL_RATIO_TYPE]: ['0', '1', 'gender', 'age'],
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
  [URL_SORT_NAME]: [
    'mau',
    'male',
    'female',
    'lt25',
    'gte25',
    'gte25_lte34',
    'gte25_lte44',
    'gte35_lte44',
    'gt44',
  ],
};

const checkDemographicsValidQuery = (history: History, validCfg: ShortLinkPageValidCfgType) => {
  const { query } = history?.location || {};
  function getValidValue(validCfg: any, query: any, urlKey: string) {
    const rawQueryValue = query?.[urlKey];
    const queryValue = typeof rawQueryValue === 'string' ? rawQueryValue.toLocaleLowerCase() : undefined;
    const validValues = validCfg?.[urlKey]?.map((t: string | boolean) => {
      if (typeof t === 'string') return t.toLocaleLowerCase();
      return String(t);
    });
    // 获取有效的值
    return validValues?.includes(queryValue) ? queryValue : validValues?.[0];
  }
  let ratio = getValidValue(validCfg, query, URL_RATIO_TYPE);
  const sortName = getValidValue(validCfg, query, URL_SORT_NAME);
  const mauOrderType = ['0', '1'];
  const genderOrderType = ['male', 'female'];
  const ageOrderType = ['lt25', 'gte25', 'gte25_lte34', 'gte25_lte44', 'gte35_lte44', 'gt44'];
  if (sortName === 'mau' && mauOrderType.indexOf(ratio) === -1) {
    ratio = mauOrderType[0];
  } else if (sortName === 'gender' && genderOrderType.indexOf(ratio) === -1) {
    ratio = genderOrderType[0];
  } else if (sortName === 'age' && ageOrderType.indexOf(ratio) === -1) {
    ratio = ageOrderType[0];
  }

  return {
    [URL_ORDER]: getValidValue(validCfg, query, URL_ORDER),
    // mau是用ratio_type, 其他是用order_type; 判断理由看排序对应的后端参数
    [URL_RATIO_TYPE]: sortName === 'mau' ? Number(ratio) : 0,
    order_type: sortName !== 'mau' ? ratio : undefined,
    [URL_SORT_NAME]: sortName,
    [URL_PAGE_SIZE]: Number(getValidValue(validCfg, query, URL_PAGE_SIZE)),
    [URL_CHART_TYPE]: getValidValue(validCfg, query, URL_CHART_TYPE),
    [URL_CHART_METRIC]: getValidValue(validCfg, query, URL_CHART_METRIC),
  };
};

export const getTopMobilesDemographicsCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkDemographicsValidQuery(history, validCfg);
  const params = {
    page_size: validParams?.[URL_PAGE_SIZE],
    order: validParams?.[URL_ORDER],
    order_type: validParams?.order_type,
    ratio_type: validParams?.[URL_RATIO_TYPE],
    order_metric: validParams?.[URL_SORT_NAME],
  };
  return { params, validQuery: validParams };
};

const getMetrictableEchartMetricValues = (ehcartMetricList: any[]) => {
  const metricValues: string[] = [];
  ehcartMetricList?.forEach((sourceItem: any) => {
    sourceItem?.children?.forEach((metricItem: any) => {
      metricValues.push(metricItem?.value);
    });
  });
  return metricValues;
};

const topchartMetrictableValidCfg: ShortLinkPageValidCfgType = {
  [URL_CHART_TYPE]: ['bar', 'line', 'pie'],
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  // [URL_PAGE_SIZE]: ['100', '50', '20'],
  // 第一项为 url 无对应有效参数时的默认值，默认 50
  [URL_PAGE_SIZE]: ['50', '10', '20', '30', '100', '200'],
};
export const topchartPCConsoleMetrictableValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: getMetrictableEchartMetricValues(
    ECHARTS_DATASOURCE_METRICS_MAP.combinePCConsoleMetricsTable,
  ),
  // [URL_SORT_NAME]: dataSourcesColumns.map(t => t?.value), // 在页面里面配置
};

export const topchartPCMetrictableValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: getMetrictableEchartMetricValues(
    ECHARTS_DATASOURCE_METRICS_MAP.pcMetricsTable,
  ),
  [URL_SORT_NAME]: pcMetricTableCloums.map((t) => t?.value),
  [URL_TABLE_SCROLL_SEG]: pcMetricTableSegementList.map((t) => t?.value),
};

export const topchartConsoleMetrictableValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: getMetrictableEchartMetricValues(
    ECHARTS_DATASOURCE_METRICS_MAP.consoleMetricsTable,
  ),
  [URL_SORT_NAME]: consleMetricTableCloums.map((t) => t?.value),
  [URL_TABLE_SCROLL_SEG]: consleMetricTableSegementList.map((t) => t?.value),
};

export const topchartPCDigitalRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.pcDigitalRevenue.map((t) => t?.value),
  [URL_SORT_NAME]: digitalRevenueList.map((t) => t?.value),
};

export const topchartConsoleDigitalRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.consoleDigitalRevenue.map((t) => t?.value),
  [URL_SORT_NAME]: digitalRevenueList.map((t) => t?.value),
};

export const topchartPCPCUValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.pcPCU.map((t) => t?.value),
  [URL_SORT_NAME]: pcuPageList.map((t) => t?.value),
};

export const topchartPCPhysicalRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.pcPhysicalRevenue.map((t) => t?.value),
  [URL_SORT_NAME]: npdList.map((t) => t?.value),
};

export const topchartConsolePhysicalRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.consolePhysicalRevenue.map((t) => t?.value),
  [URL_SORT_NAME]: npdList.map((t) => t?.value),
};

export const topchartLifetimePlayerValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: [],
  [URL_SORT_NAME]: lifetimePlayerList.map((t) => t?.value),
};

export const topchartPCMAUValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.pcMAU.map((t) => t?.value),
  [URL_SORT_NAME]: mauList.map((t) => t?.value),
};

export const topchartConsoleMAUValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: ECHARTS_DATASOURCE_METRICS_MAP.consoleMAU.map((t) => t?.value),
  [URL_SORT_NAME]: mauList.map((t) => t?.value),
};

export const topchartSteamSalesValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: SteamSalesList.map((t) => t?.value),
  [URL_SORT_NAME]: steamSalesList.map((t) => t?.value),
};

export const topchartJapansalesValidCfg: ShortLinkPageValidCfgType = {
  ...topchartMetrictableValidCfg,
  [URL_CHART_METRIC]: japanSalesSegOptions.map((t: any) => t?.value),
  [URL_SORT_NAME]: japanSalesList.map((t: any) => t?.value),
};

export const getTopPCMetricTableCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
  tableList: any[],
) => {
  const validParams = checkValidQuery(history, validCfg);
  const sortNameValue = validParams?.[URL_SORT_NAME];
  const sortNameLower = typeof sortNameValue === 'string' ? sortNameValue.toLocaleLowerCase() : '';
  
  // 优先查找 Gamalytic 版本的指标（如果存在）
  let tableItem = tableList?.find((t) => {
    const tValue = typeof t?.value === 'string' ? t.value.toLocaleLowerCase() : '';
    return tValue === `gamalytic__${sortNameLower}`;
  });
  
  // 如果没找到 Gamalytic 版本，则查找原始指标
  if (!tableItem) {
    tableItem = tableList?.find((t) => {
      const tValue = typeof t?.value === 'string' ? t.value.toLocaleLowerCase() : '';
      return tValue === sortNameLower;
    });
  }
  
  const params = {
    page_size: validParams?.[URL_PAGE_SIZE],
    order: validParams?.[URL_ORDER],
    ratio_type: validParams?.[URL_RATIO_TYPE],
    // 从表格条目中拿到对应的后端value
    order_metric: tableItem?.value,
    // 从表格条目中拿到对应的数据源
    order_source: tableItem?.metricValue || tableItem?.dataSource,
  };
  return { params, validQuery: validParams };
};

// 用于校正url上面传过来的配置参数是否有效，无效则用配置对应数组的第一个元素值
const topchartCompaniesValidCfg: ShortLinkPageValidCfgType = {
  // 页面可视化对应的柱折饼类型
  [URL_CHART_TYPE]: ['bar', 'line', 'pie'],
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
};
export const topchartCompaniesRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...topchartCompaniesValidCfg,
  // 排序的指标值，因为是动态的，所以在页面自定义处理
  // [URL_SORT_NAME]: [],
};
export const topchartCompaniesDownloadsValidCfg: ShortLinkPageValidCfgType = {
  ...topchartCompaniesValidCfg,
  // 排序的指标值
  [URL_SORT_NAME]: ['downloads'],
};
export const topchartCompaniesMetionsValidCfg: ShortLinkPageValidCfgType = {
  ...topchartCompaniesValidCfg,
  // 排序的指标值
  [URL_SORT_NAME]: ['mentions'],
};

// 获取companies榜单页面对应的有效配置
export const getTopCompaniesCustomValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  // 从短链接上拿到的页面配置
  const validParams = checkValidQuery(history, validCfg);
  // 从短链接上拿到的参数处理后传到接口
  const params = {
    // 排序升降序赋值到参数
    order: validParams?.[URL_ORDER],
    // 是否是环比排序, SumRevenue没有环比排序
    ratio_type: validParams?.[URL_RATIO_TYPE],
    // 排序指标赋值到参数
    order_metric: validParams?.[URL_SORT_NAME],
  };
  return { params, validQuery: validParams };
};

// 用于校正url上面传过来的配置参数是否有效，无效则用配置对应数组的第一个元素值
const statsActiveuserRevDownValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  // 表格指标排序对应的降序升序
  [URL_2_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_2_RATIO_TYPE]: ['0', '1'],
  // 页面可视化对应的柱折饼类型
  [URL_2_CHART_TYPE]: ['pie', 'bar', 'line'],
  [URL_RANK_SWITCH]: [false, true],
};
export const statsActiveuserValidCfg: ShortLinkPageValidCfgType = {
  ...statsActiveuserRevDownValidCfg,
  [URL_SORT_NAME]: ['time', 'dau'],
  [URL_2_SORT_NAME]: ['avg_dau'],
};
export const statsRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...statsActiveuserRevDownValidCfg,
  [URL_SORT_NAME]: ['time', 'revenue', 'arpu'],
  [URL_2_SORT_NAME]: ['sum_revenue', 'avg_revenue', 'arpu'],
};
export const statsDownloadValidCfg: ShortLinkPageValidCfgType = {
  ...statsActiveuserRevDownValidCfg,
  [URL_SORT_NAME]: ['time', 'download'],
  [URL_2_SORT_NAME]: ['sum_download', 'avg_download'],
};
// 用于校正url上面传过来的配置参数是否有效，无效则用配置对应数组的第一个元素值
const countriesActiveuserRevDownValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  // 页面可视化对应的柱折饼类型
  [URL_CHART_TYPE]: ['bar', 'pie', 'line', 'stackedLine'],
  [URL_COUNTRIES_TYPE]: ['market', 'region'],
};
export const countriesActiveuserValidCfg: ShortLinkPageValidCfgType = {
  ...countriesActiveuserRevDownValidCfg,
  // 排序的指标值
  [URL_SORT_NAME]: ['avg_dau'],
};
export const countriesRevenueValidCfg: ShortLinkPageValidCfgType = {
  ...countriesActiveuserRevDownValidCfg,
  // 排序的指标值
  [URL_SORT_NAME]: ['sum_revenue', 'avg_revenue', 'arpu'],
};
export const countriesDownloadValidCfg: ShortLinkPageValidCfgType = {
  ...countriesActiveuserRevDownValidCfg,
  // 排序的指标值
  [URL_SORT_NAME]: ['sum_download', 'avg_download'],
};

export const getDetailCommonValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  return { params: {}, validQuery: validParams };
};

export const getCountriesActiveuserRevDownValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    region_type_share: validParams?.[URL_COUNTRIES_TYPE],
  };
  return { params, validQuery: validParams };
};

const RPDKEYS = ['rpd', 'cumulative_revenue', 'cumulative_downloads'];
export const statsRPDValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  // 表格指标排序对应的降序升序
  [URL_2_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_2_RATIO_TYPE]: ['0', '1'],
  // 页面可视化对应的柱折饼类型
  [URL_2_CHART_TYPE]: ['bar', 'line'],
  [URL_SORT_NAME]: ['date', ...RPDKEYS],
  [URL_2_SORT_NAME]: [...RPDKEYS],
  [URL_CHART_METRIC]: [...RPDKEYS],
  [URL_2_CHART_METRIC]: [...RPDKEYS],
};

export const countriesRPDValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_TYPE]: ['bar', 'line', 'stackedLine'],
  [URL_COUNTRIES_TYPE]: ['market', 'region'],
  [URL_SORT_NAME]: [...RPDKEYS],
  [URL_CHART_METRIC]: [...RPDKEYS],
};

export const getStatsRPDValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  if (
    validParams[URL_SORT_NAME] !== 'date' &&
    validParams[URL_SORT_NAME] !== validParams[URL_CHART_METRIC]
  ) {
    validParams[URL_SORT_NAME] = 'date';
  }
  validParams[URL_2_SORT_NAME] = validParams[URL_2_CHART_METRIC];
  // if (validParams[URL_2_SORT_NAME] !== validParams[URL_2_CHART_METRIC]) {
  // }
  return { params: {}, validQuery: validParams };
};

export const getCountriesRPDValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const params = {
    region_type_share: validParams?.[URL_COUNTRIES_TYPE],
  };
  validParams[URL_SORT_NAME] = validParams[URL_CHART_METRIC];
  // if (validParams[URL_SORT_NAME] !== validParams[URL_CHART_METRIC]) {
  //   validParams[URL_SORT_NAME] = validParams[URL_CHART_METRIC]
  // }
  return { params, validQuery: validParams };
};

// const RETENTION_KEYS = ['D2', 'D3', 'D7', 'D15', 'D31'];
export const statsRetentionValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  // 表格指标排序对应的降序升序
  [URL_2_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_2_RATIO_TYPE]: ['0', '1'],
  // 页面可视化对应的柱折饼类型
  [URL_2_CHART_TYPE]: ['line'],
  // [URL_SORT_NAME]: ['date', ...RETENTION_KEYS],
  // [URL_2_SORT_NAME]: [...RETENTION_KEYS],
  // [URL_CHART_METRIC]: [...RETENTION_KEYS],
  // [URL_2_CHART_METRIC]: [...RETENTION_KEYS],
};

export const countriesRetentionValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  // 是否是环比排序 0值 1环比
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_TYPE]: ['line', 'stackedLine'],
  [URL_COUNTRIES_TYPE]: ['market', 'region'],
  // [URL_SORT_NAME]: [...RETENTION_KEYS],
  // [URL_CHART_METRIC]: [...RETENTION_KEYS],
};

export const getStatsRetentionValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  validParams[URL_2_SORT_NAME] = validParams[URL_2_CHART_METRIC];
  return { params: {}, validQuery: validParams };
};

export const getRetentionPageValidCfg = (urlFilter: any, validCfg: ShortLinkPageValidCfgType) => {
  // 获取表格有效列表值
  const retentionValues = urlFilter?.[filterKeyMap.RETENTION]?.value || ['D2', 'D3', 'D7'];
  const tableList: any[] = retentionValues?.map((key: string) => ({ text: key, value: key }));
  const statsValidCfg: ShortLinkPageValidCfgType = {
    ...(validCfg || {}),
    // 更新表格排序
    [URL_SORT_NAME]: ['date', ...retentionValues],
    [URL_2_SORT_NAME]: [...retentionValues],
    [URL_CHART_METRIC]: [...retentionValues],
    [URL_2_CHART_METRIC]: [...retentionValues],
  };
  const countriesValidCfg: ShortLinkPageValidCfgType = {
    ...(validCfg || {}),
    // 更新表格排序
    [URL_SORT_NAME]: [...retentionValues],
    [URL_CHART_METRIC]: [...retentionValues],
  };
  return { statsValidCfg, countriesValidCfg, tableList };
};

export const statsLifetimeRetentionValidCfg: ShortLinkPageValidCfgType = {
  // 表格指标排序对应的降序升序
  [URL_ORDER]: ['desc', 'asc'],
  [URL_SORT_NAME]: ['D2', 'D3', 'D7', 'D14', 'D30'],
};

export const detailDemographicsValidCfg: ShortLinkPageValidCfgType = {
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  [URL_CHART_TYPE]: ['pie', 'bar', 'line'],
  [URL_SORT_NAME]: ['date', 'male', 'female'],
  [URL_2_ORDER]: ['desc', 'asc'],
  [URL_2_RATIO_TYPE]: ['0', '1'],
  [URL_2_CHART_TYPE]: ['line', 'bar', 'pie'],
  [URL_2_SORT_NAME]: ['date', 'lt25', 'gte25', 'gte25_lte34', 'gte25_lte44', 'gte35_lte44', 'gt44'],
};

export const detailStreamingValidCfg: ShortLinkPageValidCfgType = {
  [URL_ORDER]: ['desc', 'asc'],
  [URL_RATIO_TYPE]: ['0', '1'],
  // [URL_SORT_NAME]: ['date', ],
  [URL_2_ORDER]: ['desc', 'asc'],
  [URL_2_RATIO_TYPE]: ['0', '1'],
  [URL_2_CHART_TYPE]: ['pie', 'bar', 'line'],
  // [URL_2_SORT_NAME]: [],
};

export const getDetailStreamingValidUrlParams = (
  history: History,
  validCfg: ShortLinkPageValidCfgType,
) => {
  const validParams = checkValidQuery(history, validCfg);
  const channelParams = {
    ratio_type: validParams?.[URL_2_RATIO_TYPE],
    order: validParams?.[URL_2_ORDER],
    order_metric:
      validParams?.[URL_2_RATIO_TYPE] === 1
        ? `${validParams?.[URL_2_SORT_NAME]}_ratio`
        : validParams?.[URL_2_SORT_NAME],
  };
  return { params: { trend: {}, channel: channelParams }, validQuery: validParams };
};
